/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup1Inputs */

const zh_auth_signup1 = /** @type {(inputs: Auth_Signup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册`)
};

const en_auth_signup1 = /** @type {(inputs: Auth_Signup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Up`)
};

const es_auth_signup1 = /** @type {(inputs: Auth_Signup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrarse`)
};

/**
* | output |
* | --- |
* | "Sign Up" |
*
* @param {Auth_Signup1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_signup1 = /** @type {((inputs?: Auth_Signup1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_signup1(inputs)
	if (locale === "en") return en_auth_signup1(inputs)
	return es_auth_signup1(inputs)
});
export { auth_signup1 as "auth_signUp" }